/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateEventInput = {
  sourceSiteId: string,
  sourceName: string,
  eventName: string,
  ownerEmail: string,
  eventKey?: string | null,
  ownerFirstName?: string | null,
  ownerLastName?: string | null,
  crmId?: string | null,
  live?: boolean | null,
  date?: string | null,
  endDate?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  locale?: string | null,
  location?: string | null,
  room?: string | null,
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null,
  description?: string | null,
  calendarStatus?: EventStatusEnum | null,
  department?: string | null,
  marketingEffort?: string | null,
  invitationMarketingEffort?: string | null,
  additionalData?: string | null,
  adminUrl?: string | null,
  publicUrl?: string | null,
};

export enum EventStatusEnum {
  UNPUBLISHED = "UNPUBLISHED",
  PUBLISHED = "PUBLISHED",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
}


export type Event = {
  __typename: "Event",
  eventId: string,
  version: string,
  sourceSiteId: string,
  sourceName: string,
  eventName: string,
  ownerEmail: string,
  eventKey?: string | null,
  ownerFirstName?: string | null,
  ownerLastName?: string | null,
  crmId?: string | null,
  live?: boolean | null,
  date?: string | null,
  endDate?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  locale?: string | null,
  location?: string | null,
  room?: string | null,
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null,
  description?: string | null,
  calendarStatus?: EventStatusEnum | null,
  department?: string | null,
  marketingEffort?: string | null,
  invitationMarketingEffort?: string | null,
  additionalData?: string | null,
  eventRole?: EventRoleEnum | null,
  publicUrl?: string | null,
  adminUrl?: string | null,
};

export enum EventRoleEnum {
  OWNER = "OWNER",
  COOWNER = "COOWNER",
  TEAM = "TEAM",
}


export type CreateEventUserInput = {
  eventId: string,
  eventRole: EventRoleEnum,
  ownerEmail: string,
};

export type UpdateEventInput = {
  eventId: string,
  sourceSiteId?: string | null,
  eventName?: string | null,
  ownerEmail?: string | null,
  ownerFirstName?: string | null,
  ownerLastName?: string | null,
  crmId?: string | null,
  live?: boolean | null,
  date?: string | null,
  endDate?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  locale?: string | null,
  location?: string | null,
  room?: string | null,
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null,
  description?: string | null,
  calendarStatus?: EventStatusEnum | null,
  department?: string | null,
  marketingEffort?: string | null,
  invitationMarketingEffort?: string | null,
  additionalData?: string | null,
  adminUrl?: string | null,
  publicUrl?: string | null,
};

export type DeleteEventInput = {
  eventId: string,
};

export type DeleteUserInput = {
  eventId: string,
  ownerEmail: string,
};

export type DeleteRegistrationInput = {
  eventId: string,
  registrationId: string,
};

export type Registration = {
  __typename: "Registration",
  registrationId: string,
  eventId: string,
  parentEventKey?: string | null,
  email?: string | null,
  crmId?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  registrationStatus?: RegistrationStatusEnum | null,
  dateCreated?: string | null,
  qrBase64?: string | null,
  pdfBase64?: string | null,
  pdfUrl?: string | null,
  live?: boolean | null,
  guests?: number | null,
  additionalData?: string | null,
  submissionId?: string | null,
  checkedInCount?: number | null,
};

export enum RegistrationStatusEnum {
  REGISTERED = "REGISTERED",
  PARTIAL_CHECK_IN = "PARTIAL_CHECK_IN",
  CHECKED_IN = "CHECKED_IN",
  CANCELLED = "CANCELLED",
  WALK_IN = "WALK_IN",
  INVITED = "INVITED",
  DELETED = "DELETED",
}


export type DeleteEventAndRegistrationsInput = {
  eventId: string,
};

export type DeleteEventAndRegistrationsPayload = {
  __typename: "DeleteEventAndRegistrationsPayload",
  success: boolean,
  message?: string | null,
};

export type CreateRegistrationInput = {
  eventId: string,
  parentEventKey?: string | null,
  email: string,
  firstName: string,
  lastName: string,
  crmId?: string | null,
  registrationStatus?: RegistrationStatusEnum | null,
  live?: boolean | null,
  guests?: number | null,
  additionalData?: string | null,
  submissionId?: string | null,
  generateQRAndTicket?: boolean | null,
};

export type UpdateRegistrationInput = {
  eventId: string,
  registrationId: string,
  email?: string | null,
  crmId?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  registrationStatus?: RegistrationStatusEnum | null,
  guests?: number | null,
  submissionId?: string | null,
  checkedInCount?: number | null,
  additionalData?: string | null,
};

export type CreateParticipationInput = {
  registrationId: string,
  eventId: string,
  actorEmail: string,
  actionType?: string | null,
  checkedInCount?: number | null,
  participationStatus?: RegistrationStatusEnum | null,
  geocoordinates?: string | null,
  crmId?: string | null,
  locationTag?: string | null,
  userAgent?: string | null,
  ipAddress?: string | null,
  deviceType?: string | null,
  deviceModel?: string | null,
  osType?: string | null,
  osVersion?: string | null,
  actionDetails?: string | null,
};

export type Participation = {
  __typename: "Participation",
  participationId: string,
  registrationId: string,
  eventId: string,
  actorEmail?: string | null,
  actionType?: string | null,
  checkedInCount?: number | null,
  participationStatus?: RegistrationStatusEnum | null,
  geocoordinates?: string | null,
  crmId?: string | null,
  locationTag?: string | null,
  userAgent?: string | null,
  ipAddress?: string | null,
  deviceType?: string | null,
  deviceModel?: string | null,
  osType?: string | null,
  osVersion?: string | null,
  createdAt?: string | null,
  actionDetails?: string | null,
};

export type GeneratePresignedUrlInput = {
  filename: string,
  fileType: string,
};

export type PresignedUrlResponse = {
  __typename: "PresignedUrlResponse",
  url: string,
  bucketName: string,
  key: string,
};

export type TableEventFilterInput = {
  eventId?: TableStringFilterInput | null,
  sourceSiteId?: TableStringFilterInput | null,
  sourceName?: TableStringFilterInput | null,
  eventName?: TableStringFilterInput | null,
  location?: TableStringFilterInput | null,
  calendarStatus?: TableStringFilterInput | null,
  date?: TableStringFilterInput | null,
  ownerEmail?: TableStringFilterInput | null,
  crmId?: TableStringFilterInput | null,
};

export type TableStringFilterInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type EventConnection = {
  __typename: "EventConnection",
  items?:  Array<Event | null > | null,
  nextToken?: string | null,
};

export type TableRegistrationFilterInput = {
  eventId?: TableStringFilterInput | null,
  registrationId?: TableStringFilterInput | null,
  email?: TableStringFilterInput | null,
  firstName?: TableStringFilterInput | null,
  lastName?: TableStringFilterInput | null,
  crmId?: TableStringFilterInput | null,
  registrationStatus?: TableStringFilterInput | null,
};

export type RegistrationConnection = {
  __typename: "RegistrationConnection",
  items?:  Array<Registration | null > | null,
  nextToken?: string | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type CreateEventUserMutationVariables = {
  input: CreateEventUserInput,
};

export type CreateEventUserMutation = {
  createEventUser?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type DeleteRegistrationMutationVariables = {
  input: DeleteRegistrationInput,
};

export type DeleteRegistrationMutation = {
  deleteRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};

export type DeleteEventAndRegistrationsMutationVariables = {
  input: DeleteEventAndRegistrationsInput,
};

export type DeleteEventAndRegistrationsMutation = {
  deleteEventAndRegistrations?:  {
    __typename: "DeleteEventAndRegistrationsPayload",
    success: boolean,
    message?: string | null,
  } | null,
};

export type CreateRegistrationMutationVariables = {
  input: CreateRegistrationInput,
};

export type CreateRegistrationMutation = {
  createRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};

export type UpdateRegistrationMutationVariables = {
  input: UpdateRegistrationInput,
};

export type UpdateRegistrationMutation = {
  updateRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};

export type CreateParticipationMutationVariables = {
  input: CreateParticipationInput,
};

export type CreateParticipationMutation = {
  createParticipation?:  {
    __typename: "Participation",
    participationId: string,
    registrationId: string,
    eventId: string,
    actorEmail?: string | null,
    actionType?: string | null,
    checkedInCount?: number | null,
    participationStatus?: RegistrationStatusEnum | null,
    geocoordinates?: string | null,
    crmId?: string | null,
    locationTag?: string | null,
    userAgent?: string | null,
    ipAddress?: string | null,
    deviceType?: string | null,
    deviceModel?: string | null,
    osType?: string | null,
    osVersion?: string | null,
    createdAt?: string | null,
    actionDetails?: string | null,
  } | null,
};

export type GeneratePresignedUrlMutationVariables = {
  input: GeneratePresignedUrlInput,
};

export type GeneratePresignedUrlMutation = {
  generatePresignedUrl?:  {
    __typename: "PresignedUrlResponse",
    url: string,
    bucketName: string,
    key: string,
  } | null,
};

export type GetEventQueryVariables = {
  eventId: string,
  version: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type ListEventsQueryVariables = {
  filter?: TableEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "EventConnection",
    items?:  Array< {
      __typename: "Event",
      eventId: string,
      version: string,
      sourceSiteId: string,
      sourceName: string,
      eventName: string,
      ownerEmail: string,
      eventKey?: string | null,
      ownerFirstName?: string | null,
      ownerLastName?: string | null,
      crmId?: string | null,
      live?: boolean | null,
      date?: string | null,
      endDate?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      locale?: string | null,
      location?: string | null,
      room?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zipCode?: string | null,
      description?: string | null,
      calendarStatus?: EventStatusEnum | null,
      department?: string | null,
      marketingEffort?: string | null,
      invitationMarketingEffort?: string | null,
      additionalData?: string | null,
      eventRole?: EventRoleEnum | null,
      publicUrl?: string | null,
      adminUrl?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListEventsByEmailQueryVariables = {
  ownerEmail: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsByEmailQuery = {
  listEventsByEmail?:  {
    __typename: "EventConnection",
    items?:  Array< {
      __typename: "Event",
      eventId: string,
      version: string,
      sourceSiteId: string,
      sourceName: string,
      eventName: string,
      ownerEmail: string,
      eventKey?: string | null,
      ownerFirstName?: string | null,
      ownerLastName?: string | null,
      crmId?: string | null,
      live?: boolean | null,
      date?: string | null,
      endDate?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      locale?: string | null,
      location?: string | null,
      room?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zipCode?: string | null,
      description?: string | null,
      calendarStatus?: EventStatusEnum | null,
      department?: string | null,
      marketingEffort?: string | null,
      invitationMarketingEffort?: string | null,
      additionalData?: string | null,
      eventRole?: EventRoleEnum | null,
      publicUrl?: string | null,
      adminUrl?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetRegistrationQueryVariables = {
  registrationId: string,
  eventId: string,
};

export type GetRegistrationQuery = {
  getRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};

export type ListRegistrationsQueryVariables = {
  filter?: TableRegistrationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRegistrationsQuery = {
  listRegistrations?:  {
    __typename: "RegistrationConnection",
    items?:  Array< {
      __typename: "Registration",
      registrationId: string,
      eventId: string,
      parentEventKey?: string | null,
      email?: string | null,
      crmId?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      registrationStatus?: RegistrationStatusEnum | null,
      dateCreated?: string | null,
      qrBase64?: string | null,
      pdfBase64?: string | null,
      pdfUrl?: string | null,
      live?: boolean | null,
      guests?: number | null,
      additionalData?: string | null,
      submissionId?: string | null,
      checkedInCount?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListEventsByCalendarStatusQueryVariables = {
  calendarStatus: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsByCalendarStatusQuery = {
  listEventsByCalendarStatus?:  {
    __typename: "EventConnection",
    items?:  Array< {
      __typename: "Event",
      eventId: string,
      version: string,
      sourceSiteId: string,
      sourceName: string,
      eventName: string,
      ownerEmail: string,
      eventKey?: string | null,
      ownerFirstName?: string | null,
      ownerLastName?: string | null,
      crmId?: string | null,
      live?: boolean | null,
      date?: string | null,
      endDate?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      locale?: string | null,
      location?: string | null,
      room?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zipCode?: string | null,
      description?: string | null,
      calendarStatus?: EventStatusEnum | null,
      department?: string | null,
      marketingEffort?: string | null,
      invitationMarketingEffort?: string | null,
      additionalData?: string | null,
      eventRole?: EventRoleEnum | null,
      publicUrl?: string | null,
      adminUrl?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListRegistrationsByEventIdQueryVariables = {
  eventId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRegistrationsByEventIdQuery = {
  listRegistrationsByEventId?:  {
    __typename: "RegistrationConnection",
    items?:  Array< {
      __typename: "Registration",
      registrationId: string,
      eventId: string,
      parentEventKey?: string | null,
      email?: string | null,
      crmId?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      registrationStatus?: RegistrationStatusEnum | null,
      dateCreated?: string | null,
      qrBase64?: string | null,
      pdfBase64?: string | null,
      pdfUrl?: string | null,
      live?: boolean | null,
      guests?: number | null,
      additionalData?: string | null,
      submissionId?: string | null,
      checkedInCount?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListRegistrationsByEmailQueryVariables = {
  email: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRegistrationsByEmailQuery = {
  listRegistrationsByEmail?:  {
    __typename: "RegistrationConnection",
    items?:  Array< {
      __typename: "Registration",
      registrationId: string,
      eventId: string,
      parentEventKey?: string | null,
      email?: string | null,
      crmId?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      registrationStatus?: RegistrationStatusEnum | null,
      dateCreated?: string | null,
      qrBase64?: string | null,
      pdfBase64?: string | null,
      pdfUrl?: string | null,
      live?: boolean | null,
      guests?: number | null,
      additionalData?: string | null,
      submissionId?: string | null,
      checkedInCount?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
  eventId?: string | null,
  sourceSiteId?: string | null,
  sourceName?: string | null,
  eventName?: string | null,
  location?: string | null,
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
  eventId?: string | null,
  sourceSiteId?: string | null,
  sourceName?: string | null,
  eventName?: string | null,
  location?: string | null,
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
  eventId?: string | null,
  sourceSiteId?: string | null,
  sourceName?: string | null,
  eventName?: string | null,
  location?: string | null,
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    eventId: string,
    version: string,
    sourceSiteId: string,
    sourceName: string,
    eventName: string,
    ownerEmail: string,
    eventKey?: string | null,
    ownerFirstName?: string | null,
    ownerLastName?: string | null,
    crmId?: string | null,
    live?: boolean | null,
    date?: string | null,
    endDate?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    locale?: string | null,
    location?: string | null,
    room?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zipCode?: string | null,
    description?: string | null,
    calendarStatus?: EventStatusEnum | null,
    department?: string | null,
    marketingEffort?: string | null,
    invitationMarketingEffort?: string | null,
    additionalData?: string | null,
    eventRole?: EventRoleEnum | null,
    publicUrl?: string | null,
    adminUrl?: string | null,
  } | null,
};

export type OnCreateRegistrationSubscriptionVariables = {
  eventId?: string | null,
};

export type OnCreateRegistrationSubscription = {
  onCreateRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};

export type OnUpdateRegistrationSubscriptionVariables = {
  eventId?: string | null,
};

export type OnUpdateRegistrationSubscription = {
  onUpdateRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};

export type OnDeleteRegistrationSubscriptionVariables = {
  eventId?: string | null,
};

export type OnDeleteRegistrationSubscription = {
  onDeleteRegistration?:  {
    __typename: "Registration",
    registrationId: string,
    eventId: string,
    parentEventKey?: string | null,
    email?: string | null,
    crmId?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    registrationStatus?: RegistrationStatusEnum | null,
    dateCreated?: string | null,
    qrBase64?: string | null,
    pdfBase64?: string | null,
    pdfUrl?: string | null,
    live?: boolean | null,
    guests?: number | null,
    additionalData?: string | null,
    submissionId?: string | null,
    checkedInCount?: number | null,
  } | null,
};
